import React from "react";
import { useTranslation } from "../../i18n/useTranslation";

const HomeNumbers = () => {
  const { t } = useTranslation();

  return (
    <section
      className="py-20 xl:py-24 bg-white bg-center"
      style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
    >
      <div className="container">
        <div className="text-center">
          <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 uppercase rounded-full">
            {t("numbersTag")}
          </span>
          <h2 className="mb-4 text-2xl md:text-3xl !leading-tight text-slate-800 font-bold tracking-tight">
            {t("numbersTitle")}
          </h2>
          <p className="mb-24 text-base md:text-lg text-slate-500">
            {t("numbersDesc")}
          </p>
        </div>
        <div className="sm:grid sm:grid-cols-2 lg:grid-cols-4 -mx-4 text-center text-slate-800">
          <div className=" px-4 mb-8">
            <p className="py-4 text-3xl font-bold text-blue-600">10.000+</p>
            <h3 className="text-slate-500">{t("numbersStat1")}</h3>
          </div>
          <div className=" px-4 mb-8">
            <p className="py-4 text-3xl font-bold text-blue-600">500.000+</p>
            <h3 className="text-slate-500">{t("numbersStat2")}</h3>
          </div>
          <div className=" px-4 mb-8">
            <p className="py-4 text-3xl font-bold text-blue-600">100.000+</p>
            <h3 className="text-slate-500">{t("numbersStat3")}</h3>
          </div>
          <div className=" px-4 mb-8 md:mb-0">
            <p className="py-4 text-3xl font-bold text-blue-600">5.000+</p>
            <h3 className="text-slate-500">{t("numbersStat4")}</h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeNumbers;
